import { Customer } from 'types/generatedSchemaTypes';

export const emptyCustomer: Customer = {
  uid: '',
  countryCode: 'FI',
  customerType: 'B2C',
  firstName: '',
  lastName: '',
};
